import { aiPhotoGenerationFreeLimit, aiPhotoGenerationPaidLimit } from 'reactApp/appHelpers/featuresHelpers/features/aiPhotoGeneration';
import type { IAiGenerationState } from 'reactApp/modules/aiPhotoGeneration/aiPhotoGeneration.types';
import { UserSelectors } from 'reactApp/modules/user/user.selectors';
import type { RootState } from 'reactApp/store';
import { createSelector } from 'reselect';

export const getAiGenerationState = (state: RootState): IAiGenerationState => state.aiGeneration;

export const getAiGenerationImageState = (state: RootState) => getAiGenerationState(state).generation.state;

export const getAiGenerationImagePercentage = (state: RootState) => getAiGenerationState(state).generation.percentage;

export const getAiGenerationStartTime = (state: RootState) => getAiGenerationState(state).generation.startTime;

export const getAiGenerationImage = (state: RootState) => getAiGenerationState(state).generation.image;

export const getAiGenerationImageSize = (state: RootState) => getAiGenerationState(state).generation.size;

export const getAiGenerationPrompt = (state: RootState) => getAiGenerationState(state).prompt;

export const getAiGenerationStyle = (state: RootState) => getAiGenerationState(state).style;

export const getAiGenerationTime = (state: RootState) => getAiGenerationState(state).generation.time;

export const getAiGenerationImageLoaderTextVariant = (state: RootState) => getAiGenerationState(state).generation.textVariant;

export const getAiPhotoGenerationLimit = createSelector(
    [UserSelectors.isPaidUser, UserSelectors.isCorpUser],
    (isPaidUser, isCorpUser): number => (isPaidUser || isCorpUser ? aiPhotoGenerationPaidLimit : aiPhotoGenerationFreeLimit)
);

export const getAiPhotoGenerationSaved = (state: RootState) => getAiGenerationState(state).generation.saved;
export const getAiPhotoGenerationRated = (state: RootState) => getAiGenerationState(state).generation.rated;
export const getAiPhotoGenerationCommented = (state: RootState) => getAiGenerationState(state).generation.commented;
